import { Link } from "react-router-dom";
import LocationMap, { AVIARY_DIRECTIONS_URL } from "components/LocationMap";

const FindUs = () => (
  <section className="bg-[#f1ebe2] py-20 md:py-28">
    <div className="container grid grid-cols-1 gap-10 md:grid-cols-2 md:items-center">
      <div>
        <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-amber">
          Visit Us
        </p>
        <h2 className="mb-4 font-didot text-4xl leading-[1.12] text-brand-dark sm:text-5xl">
          Find Us in Baesa, Quezon City
        </h2>
        <p className="mb-6 max-w-md text-lg leading-relaxed text-brand-dark/65">
          Jojo Street, Baesa
          <br />
          Quezon City, 1106 Philippines
        </p>
        <div className="flex flex-wrap gap-4">
          <a
            href={AVIARY_DIRECTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-brand-amber px-6 py-2.5 text-sm font-semibold text-black transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-amber-dark"
          >
            Get Directions
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 border-b border-brand-dark pb-0.5 text-sm font-bold uppercase tracking-[0.18em] text-brand-dark transition-opacity hover:opacity-60"
          >
            Contact Us <span className="text-base">↗</span>
          </Link>
        </div>
      </div>
      <LocationMap height="380px" />
    </div>
  </section>
);

export default FindUs;
